import { render, staticRenderFns } from "./apiList.vue?vue&type=template&id=05055334&"
import script from "./apiList.vue?vue&type=script&lang=ts&"
export * from "./apiList.vue?vue&type=script&lang=ts&"
import style0 from "./apiList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports